import { INiche } from "@/common/services/types";

import { NichePreviewAvatar } from "@/components/niches/NichePreviewAvatar";
import { NichePreviewInfo } from "@/components/niches/NichePreviewInfo";
import { NichePreviewButton } from "@/components/niches/NichePreviewButton";
import { NichePreviewImages } from "@/components/niches/NichePreviewImages";

import "./NichePreview.scss";
import { useSfw } from "@/common/hooks/useSfw";
import { metricsBus, EventSource, NichePreviewClickInitiator } from "@/common/buses";
import { useAnalyticsStore } from "@/common/store/analyticsStore";

interface INichePreviewProps {
  niche: INiche;
  withWatchButton?: boolean;
  withPreview?: boolean;
  onPreviewClick?: () => void;
}

export const NichePreview = (props: INichePreviewProps) => {
  const {
    withPreview,
    withWatchButton,
    onPreviewClick
  } = props;

  const { isLoading, sanitizeNiche } = useSfw();
  const eventSource = useAnalyticsStore((state) => state.eventSource);

  const niche = sanitizeNiche(props.niche);

  const emitPreviewClick = (initiator: NichePreviewClickInitiator) => {
    metricsBus.emit("nichePreviewClicked", {
      nicheId: niche.id,
      initiator,
      source: eventSource?.name ?? EventSource.Other,
    });
  };

  const onMetaClick = () => {
    onPreviewClick?.();
    emitPreviewClick("meta");
  };

  const onImageClick = () => {
    onPreviewClick?.();
    emitPreviewClick("image");
  };

  const onButtonClick = (initiator: NichePreviewClickInitiator) => {
    onPreviewClick?.();
    emitPreviewClick(initiator);
  };

  if (isLoading) {
    return null;
  }

  return (
    <div className="NichePreview">
      <div className="NichePreview-Header">
        <NichePreviewAvatar niche={niche} onPreviewClick={onMetaClick} />
        <NichePreviewInfo niche={niche} onPreviewClick={onMetaClick} />
        <NichePreviewButton
          niche={niche}
          withWatchButton={withWatchButton}
          onPreviewClick={onButtonClick} />
      </div>

      <NichePreviewImages niche={niche} withPreview={withPreview} onPreviewClick={onImageClick} />
    </div>
  );
};
